<template>
  <div class="slideshow" ref="container">
    <img v-for="(slide, index) in slides" :data-visible="index === current" :src="shopifyImg(slide.src)">
    <button title="Previous" @click.prevent="slide('previous')"></button>
    <button title="Next" @click.prevent="slide('next')"></button>
  </div>
</template>

<script>
import imagesLoaded from 'imagesloaded'
import resizeShopifyImgUrl from 'assets/js/resizeShopifyImgUrl'
export default {
  name: 'slideshow',
  props: ['images'],
  data () {
    return {
      slides: [],
      current: 0,
      autoplay: null
    }
  },
  methods: {
    next () {
      this.current++
      this.current = this.current % this.slides.length
    },
    previous () {
      this.current--
      this.current = this.current === -1 ? this.slides.length - 1 : this.current
    },
    startAutoplay () {
      this.autoplay = setInterval(() => {
        this.next()
      }, 3000)
    },
    slide (direction) {
      clearInterval(this.autoplay)
      this[direction]()
      this.startAutoplay()
    },
    shopifyImg (src) {
      const size = window.innerWidth > 600 ? 1024 : 600
      return resizeShopifyImgUrl(src, size)
    }
  },
  created () {
    // generate slides object
    for (var i = 0; i < this.images.length; i++) {
      const slide = {}
      slide.src = this.images[i].src
      slide.visible = i === 0
      this.slides.push(slide)
    }
  },
  mounted () {
    this.startAutoplay()
    // images loaded
    imagesLoaded(this.$refs.container, () => {
      this.$emit('imgsloaded')
    })
  },
  destroyed () {
    clearInterval(this.autoplay)
  }
}
</script>

<style lang="scss">
@import '../style/variables';
.slideshow{
  position:relative;
  > img {
    position:absolute;
    top:0; left:0;
    width:100%;
    z-index:0;
    display:block;
    // hide show
    opacity:0;    
    @include transition(opacity .5s);
    &[data-visible]{
      position:static;
      opacity:1;
    }
  }
  > button{
    @include background(absolute, 100%);
    width:50%;
    z-index:10;
    cursor:w-resize;
    &[title="Next"]{
      left:50%;
      cursor:e-resize;
    }
  }
}
</style>



// WEBPACK FOOTER //
// Slideshow.vue?1a55dea8